import { Component } from '@angular/core';

@Component({
  selector: 'app-packages',
  template: `
    <!-- ========== PAGE HERO ========== -->
    <section class="ds-page-hero">
      <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
      <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
      <div class="container ds-page-hero__inner">
        <span class="ds-pill">Paketler</span>
        <h1>Size Uygun Paketi Seçin</h1>
        <p class="ds-lead">E-ticaret sitenizin büyüklüğüne ve ihtiyaçlarınıza göre en uygun paketi seçebilirsiniz.</p>
      </div>
    </section>

    <section class="ds-section">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-3 col-md-6">
            <div class="price-card">
              <div class="price-header">
                <h4>Starter</h4>
                <p class="price-desc">Küçük mağazalar için temel özellikler.</p>
                <div class="price-value">$24</div>
                <div class="price-period">aylık</div>
              </div>
              <div class="price-features">
                <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">Demo Talep Et</a>
                <div class="price-includes">İçerir</div>
                <ul>
                  <li class="price-quota">1.000 mesajlaşma</li>
                  <li class="price-quota">10 dakika konuşma</li>
                  <li class="price-quota">1.000 Ürün</li>
                  <li>Gelişmiş ürün bilgileri</li>
                  <li>Sipariş durumu takibi</li>
                  <li>E-posta desteği</li>
                  <li>Admin paneli</li>
                  <li>Ekstra bilgi yükleyebilme</li>
                  <li>Kapsamlı müşteri destek asistanı</li>
                  <li>Ticket yönetimi</li>
                  <li>Gelişmiş satış asistanı</li>
                  <li>Sepet işlemleri</li>
                  <li>Gelişmiş AI raporlama</li>
                  <li>Instagram AI entegrasyonu</li>
                  <li>Facebook AI entegrasyonu</li>
                  <li>WhatsApp AI entegrasyonu</li>
                  <li>Telegram AI entegrasyonu</li>
                  <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
                  <li>Özel API bağlantıları</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="price-card">
              <div class="price-header">
                <h4>Pro</h4>
                <p class="price-desc">Büyüyen işletmeler için en iyi değer.</p>
                <div class="price-value">$74</div>
                <div class="price-period">aylık</div>
              </div>
              <div class="price-features">
                <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">Demo Talep Et</a>
                <div class="price-includes">İçerir</div>
                <ul>
                  <li class="price-quota">3.000 mesajlaşma</li>
                  <li class="price-quota">30 dakika konuşma</li>
                  <li class="price-quota">10.000 Ürün</li>
                  <li>Gelişmiş ürün bilgileri</li>
                  <li>Sipariş durumu takibi</li>
                  <li>E-posta desteği</li>
                  <li>Admin paneli</li>
                  <li>Ekstra bilgi yükleyebilme</li>
                  <li>Kapsamlı müşteri destek asistanı</li>
                  <li>Ticket yönetimi</li>
                  <li>Gelişmiş satış asistanı</li>
                  <li>Sepet işlemleri</li>
                  <li>Gelişmiş AI raporlama</li>
                  <li>Instagram AI entegrasyonu</li>
                  <li>Facebook AI entegrasyonu</li>
                  <li>WhatsApp AI entegrasyonu</li>
                  <li>Telegram AI entegrasyonu</li>
                  <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
                  <li>Özel API bağlantıları</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="price-card">
              <div class="price-header">
                <h4>Enterprise</h4>
                <p class="price-desc">Büyük ölçek için maksimum güç.</p>
                <div class="price-value">$244</div>
                <div class="price-period">aylık</div>
              </div>
              <div class="price-features">
                <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">Demo Talep Et</a>
                <div class="price-includes">İçerir</div>
                <ul>
                  <li class="price-quota">10.000 mesajlaşma</li>
                  <li class="price-quota">90 dakika konuşma</li>
                  <li class="price-quota">25.000 Ürün</li>
                  <li>Gelişmiş ürün bilgileri</li>
                  <li>Sipariş durumu takibi</li>
                  <li>E-posta desteği</li>
                  <li>Admin paneli</li>
                  <li>Ekstra bilgi yükleyebilme</li>
                  <li>Kapsamlı müşteri destek asistanı</li>
                  <li>Ticket yönetimi</li>
                  <li>Gelişmiş satış asistanı</li>
                  <li>Sepet işlemleri</li>
                  <li>Gelişmiş AI raporlama</li>
                  <li>Instagram AI entegrasyonu</li>
                  <li>Facebook AI entegrasyonu</li>
                  <li>WhatsApp AI entegrasyonu</li>
                  <li>Telegram AI entegrasyonu</li>
                  <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
                  <li>Özel API bağlantıları</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="price-card">
              <div class="price-header">
                <h4>Custom</h4>
                <p class="price-desc">Ölçeğinize ve iş akışlarınıza göre özelleştirilir.</p>
                <div class="price-value">Özel</div>
                <div class="price-period">fiyatlandırma</div>
              </div>
              <div class="price-features">
                <a routerLink="/contact" fragment="contact-form" class="btn btn-outline-primary d-block mb-4">İletişime Geçin</a>
                <div class="price-includes">İçerir</div>
                <ul>
                  <li class="price-quota">Sınırsız mesajlaşma</li>
                  <li class="price-quota">Sınırsız konuşma</li>
                  <li class="price-quota">Sınırsız Ürün</li>
                  <li>Gelişmiş ürün bilgileri</li>
                  <li>Sipariş durumu takibi</li>
                  <li>E-posta desteği</li>
                  <li>Admin paneli</li>
                  <li>Ekstra bilgi yükleyebilme</li>
                  <li>Kapsamlı müşteri destek asistanı</li>
                  <li>Ticket yönetimi</li>
                  <li>Gelişmiş satış asistanı</li>
                  <li>Sepet işlemleri</li>
                  <li>Gelişmiş AI raporlama</li>
                  <li>Instagram AI entegrasyonu</li>
                  <li>Facebook AI entegrasyonu</li>
                  <li>WhatsApp AI entegrasyonu</li>
                  <li>Telegram AI entegrasyonu</li>
                  <li>Pazaryeri Entegrasyonu (Trendyol, Hepsiburada, N11, Amazon)</li>
                  <li>Özel API bağlantıları</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- ===== Add-on packages ===== -->
        <div class="ds-addons">
          <div class="ds-addons__head">
            <span class="ds-pill">Ek Paketler</span>
            <h3>Mevcut Paketinizi Genişletin</h3>
            <p>Sosyal medya kanallarınıza Keyo AI entegrasyonu ekleyin.</p>
          </div>

          <div class="ds-addons__list">
            <div class="ds-addon">
              <div class="ds-addon__icon ds-addon__icon--message">
                <i class="fas fa-comment-dots"></i>
              </div>
              <div class="ds-addon__body">
                <h4>Ekstra 1000 AI mesajı</h4>
                <p>Paketinizin mesaj limitini 1.000 AI mesajı ile genişletin.</p>
              </div>
              <div class="ds-addon__price">
                <strong>$40</strong>
                <span>aylık</span>
              </div>
              <a routerLink="/contact" class="btn btn-outline-primary ds-addon__cta">Ekle</a>
            </div>

            <div class="ds-addon">
              <div class="ds-addon__icon ds-addon__icon--voice">
                <i class="fas fa-microphone"></i>
              </div>
              <div class="ds-addon__body">
                <h4>Ekstra 100 dakika konuşma</h4>
                <p>Sesli asistan sürenizi 100 dakika konuşma ile artırın.</p>
              </div>
              <div class="ds-addon__price">
                <strong>$40</strong>
                <span>aylık</span>
              </div>
              <a routerLink="/contact" class="btn btn-outline-primary ds-addon__cta">Ekle</a>
            </div>
          </div>
        </div>

        <div class="text-center mt-5">
          <a routerLink="/contact" class="btn btn-outline-primary">Detaylı Bilgi İçin İletişime Geçin</a>
        </div>
      </div>
    </section>

    <!-- ========== FINAL CTA ========== -->
    <section class="ds-final-cta">
      <div class="container">
        <div class="ds-final-cta__panel">
          <div class="ds-orb ds-orb--soft ds-final-cta__orb"></div>
          <div class="ds-final-cta__content">
            <h2>Hangi Paket Sizin İçin Doğru?</h2>
            <p class="ds-lead">Demo talebinde bulunun, size en uygun paketi birlikte seçelim.</p>
            <a routerLink="/contact" fragment="contact-form" class="btn btn-light btn-lg mt-3">Demo Talep Et</a>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .ds-pkg__head {
      margin-bottom: 64px;
    }
    .ds-pkg__head .ds-lead {
      max-width: 60ch;
      margin: 0 auto;
    }

    .price-card {
      border-radius: var(--ds-radius-panel);
      overflow: hidden;
      background: var(--ds-bg);
      box-shadow: var(--ds-shadow-card);
      border: none;
      transition: box-shadow var(--ds-motion-base), transform var(--ds-motion-base);
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .price-card:hover {
      box-shadow: var(--ds-shadow-hero);
      transform: translateY(-2px);
    }
    .price-card.highlighted {
      position: relative;
      outline: 2px solid var(--ds-cobalt);
      outline-offset: -2px;
    }
    .price-card.highlighted::before {
      content: "Popüler";
      position: absolute;
      top: 16px;
      right: 16px;
      background: var(--ds-cobalt);
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      padding: 4px 10px;
      border-radius: var(--ds-radius-pill);
      z-index: 1;
    }
    .price-header {
      padding: 22px 22px 16px;
      background: var(--ds-bg-soft);
      text-align: center;
    }
    .price-header h4 {
      margin-bottom: 0.125rem;
      font-size: 1rem;
      font-weight: 600;
      color: var(--ds-text-display);
    }
    .highlighted .price-header {
      background: radial-gradient(circle at 50% 0%, rgba(13,110,253,0.5), transparent 60%), var(--ds-midnight);
      color: #fff;
    }
    .highlighted .price-header h4 { color: #fff; }
    .price-value {
      font-size: 2.125rem;
      font-weight: 500;
      letter-spacing: -0.02em;
      margin: 0.5rem 0 0.125rem;
      color: var(--ds-text-display);
      line-height: 1;
    }
    .highlighted .price-value { color: #fff; }
    .price-desc {
      font-size: 12.5px;
      line-height: 1.4;
      color: var(--ds-text-muted);
      margin: 0.375rem auto 0;
      max-width: 22ch;
      min-height: 2.6em;
    }
    .highlighted .price-desc { color: rgba(255,255,255,0.72); }
    .price-period {
      font-size: 0.8125rem;
      color: var(--ds-text-muted);
    }
    .highlighted .price-period { color: rgba(255,255,255,0.72); }
    .price-includes {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: var(--ds-text-muted);
      margin-bottom: 10px;
    }
    .price-features li.price-quota {
      font-weight: 600;
      color: var(--ds-text-display);
    }
    .price-features {
      padding: 20px 22px 22px;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .price-features ul {
      list-style: none;
      padding: 0;
      margin: 0 0 auto 0;
    }
    .price-features li {
      padding: 6px 0 6px 22px;
      position: relative;
      font-size: 13.5px;
      line-height: 1.4;
      color: var(--ds-text);
    }
    .price-features li::before {
      content: '\\f00c';
      font-family: 'Font Awesome 6 Free';
      font-weight: 900;
      position: absolute;
      left: 0;
      top: 8px;
      color: var(--ds-cobalt);
      font-size: 11px;
    }
    .price-features .btn {
      padding: 9px 16px;
      font-size: 14px;
    }

    /* ===== Add-on packages ===== */
    .ds-addons { margin-top: 64px; }
    @media (max-width: 768px) { .ds-addons { margin-top: 48px; } }

    .ds-addons__head {
      text-align: center;
      margin-bottom: 28px;
    }
    .ds-addons__head .ds-pill { margin-bottom: 1rem; }
    .ds-addons__head h3 {
      font-size: 1.625rem;
      font-weight: 500;
      letter-spacing: -0.015em;
      margin: 0 0 0.5rem;
      color: var(--ds-text-display);
    }
    .ds-addons__head p {
      margin: 0;
      color: var(--ds-text);
      font-size: 15px;
    }

    .ds-addons__list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .ds-addon {
      display: flex;
      align-items: center;
      gap: 20px;
      padding: 18px 24px;
      background: var(--ds-bg);
      border: 1px solid var(--ds-border);
      border-radius: var(--ds-radius-card);
      box-shadow: var(--ds-shadow-card);
      transition: box-shadow var(--ds-motion-base),
                  transform var(--ds-motion-base),
                  border-color var(--ds-motion-base);
    }
    .ds-addon:hover {
      box-shadow: var(--ds-shadow-hero);
      transform: translateY(-1px);
      border-color: rgba(0,71,171,0.20);
    }

    .ds-addon__icon {
      width: 44px;
      height: 44px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 1.125rem;
      flex-shrink: 0;
      box-shadow: 0 6px 14px -6px rgba(0,0,0,0.20);
    }
    .ds-addon__icon--message { background: var(--ds-cobalt); }
    .ds-addon__icon--voice {
      background: linear-gradient(135deg, var(--ds-cobalt) 0%, var(--ds-midnight) 100%);
    }

    .ds-addon__body { flex: 1; min-width: 0; }
    .ds-addon__body h4 {
      font-size: 1rem;
      font-weight: 600;
      color: var(--ds-text-display);
      margin: 0 0 0.125rem;
    }
    .ds-addon__body p {
      font-size: 13.5px;
      line-height: 1.4;
      color: var(--ds-text);
      margin: 0;
    }

    .ds-addon__price {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      flex-shrink: 0;
      text-align: right;
      min-width: 80px;
    }
    .ds-addon__price strong {
      font-size: 1.5rem;
      font-weight: 500;
      color: var(--ds-text-display);
      letter-spacing: -0.015em;
      line-height: 1;
    }
    .ds-addon__price span {
      font-size: 12px;
      color: var(--ds-text-muted);
      margin-top: 2px;
    }

    .ds-addon__cta {
      padding: 9px 20px;
      font-size: 14px;
      flex-shrink: 0;
    }

    @media (max-width: 768px) {
      .ds-addon {
        flex-wrap: wrap;
        padding: 16px;
        gap: 14px;
      }
      .ds-addon__body { flex: 1 1 calc(100% - 60px); }
      .ds-addon__price {
        order: 3;
        flex: 1;
        align-items: flex-start;
        text-align: left;
      }
      .ds-addon__cta { order: 4; }
    }
  `]
})
export class PackagesComponent {}
